import React, { useEffect, useState } from "react";
import SecondaryButton from "../../../ui/SecondaryButton";
import { SquadSystemFit } from "./SquadSystemFit";
import LabelText from "../../../ui/LabelText";
import CustomDropdown from "../../../ui/CustomDropdown";
import TeamPlayingStyle from "./TeamPlayingStyle";
import styled from "styled-components";
import IApiResponse from "../../../types/IApiResponse";
import handleApiResponse from "../../../utils/handleApiResponse";
import { IseasonData } from "../../../types/IClubDetail";
import { fetchData } from "../../../services/api";
import apiUrls from "../../../config/apiUrls";
import GameModel from "./GameModel";

const MarketValueContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  .secondary-cta-text {
    padding-right: 0px;
  }
`;

interface IPerformanceProps {
  teamId: string;
  clubImg: string;
  clubName?: string | undefined;
}
const onthePitchOption = ['Game model','Playing Style','System fit']
// const onthePitchOption = ['System fit','Game model']
const PerformanceTab : React.FC<IPerformanceProps> = ({teamId , clubImg , clubName}) => {

  const [seasonId, setSeasonId] = useState<number>();
  const [seasonIdForAttributes, setSeasonIdForAttributes] = useState<number>();
  const [seasonData, setSeasonData] = useState<any[]>([]);
  const [seasonLabel, setSeasonLabel] = useState("");
  const [slectedTeamOnthePitchOption, setSelectedTeamOnthePitchOption] = useState<string>('System fit')
  
  useEffect(() => {
    setSelectedTeamOnthePitchOption('System fit')
    const fetchSeasonData = async () => {
      const response: IApiResponse<IseasonData> = await fetchData(`${apiUrls["GetAllCompetitionSeasonsByTeamId"]}?TeamId=${teamId}`);
      handleApiResponse(
        response,
        (teamsData) => {
          setSeasonData(teamsData.seasonData);
          setSeasonId(teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId);
          setSeasonIdForAttributes(0);
          const matchedSeason = teamsData.seasonData.find((season) => season.value === (teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId));
          if (matchedSeason) {
            setSeasonLabel(matchedSeason.label);
          }
        },
        (error) => {
          console.error("Error fetching competition season Data:", error);
        }
      );
    };
    fetchSeasonData();
  }, [teamId]);

  const handleSeasonChange = (seasonId: string) => {
    setSeasonId(Number(seasonId));
    setSeasonIdForAttributes(Number(seasonId));
    const matchedSeason = seasonData.find((season) => season.value === seasonId);
    if (matchedSeason) {
      setSeasonLabel(matchedSeason.label);
    }
  };

  const handleonthePitchOptionClick = (option: string) => {
    setSelectedTeamOnthePitchOption(option)
  }
  return (
    <div style={{paddingTop:'38px'}}>
       <div className="market-value-section">
          <MarketValueContainer className="market-value-container">
            <div className="onpitch-dropdown">
              {/* <LabelText className="drawer-title">{slectedTeamOnthePitchOption === 'Playing Style' ? 'On the Pitch' : ''}</LabelText>
              <div className="custom-dropdown season-drodown" style={{border: 'none', paddingBottom: '0px', zIndex: 8 }}>
                {slectedTeamOnthePitchOption === 'Playing Style' && (
                    <CustomDropdown
                    placeholder="SEASON"
                    options={seasonData}
                    onChange={handleSeasonChange}
                    deafaultSelected={seasonLabel}
                    isDisplaySearchInput={false}
                  />
                )}
                
              </div> */}
            </div>
            <div className="career-market-value-buttons">
              {onthePitchOption.map(option => (
                <SecondaryButton
                  key={option}
                  label={option}
                  isSelected={slectedTeamOnthePitchOption === option}
                  onClick={() => handleonthePitchOptionClick(option)}
                />
              ))}
            </div>
          </MarketValueContainer>
          {slectedTeamOnthePitchOption === 'Playing Style' &&(
              <MarketValueContainer className="market-value-container">
              <div className="onpitch-dropdown">
              <LabelText className="drawer-title">Playing Style</LabelText>
              
                <div className="custom-dropdown season-drodown" style={{border: 'none', paddingBottom: '0px', zIndex: 8 }}>
                      <CustomDropdown
                      placeholder="SEASON"
                      options={seasonData}
                      onChange={handleSeasonChange}
                      deafaultSelected={seasonLabel}
                      isDisplaySearchInput={false}
                      Id={Number(teamId)}
                    />
                </div>
                </div>
                {/* <div className="career-market-value-buttons">
                  {onthePitchOption.map(option => (
                    <SecondaryButton
                      key={option}
                      label={option}
                      isSelected={slectedTeamOnthePitchOption === option}
                      onClick={() => handleonthePitchOptionClick(option)}
                    />
                  ))}
                </div> */}
              </MarketValueContainer>
          )}
         
          {slectedTeamOnthePitchOption === "Playing Style" && (
              <TeamPlayingStyle teamId={Number(teamId)} seasonId={seasonId!} clubName={clubName!} seasonIdForAttributes={seasonIdForAttributes!}/>
          )}
          {slectedTeamOnthePitchOption === "Game model" && (
            <>
                  <GameModel teamId={Number(teamId)} />
            
            </>
          )}
          {slectedTeamOnthePitchOption === "System fit" && (
                  <SquadSystemFit team={Number(teamId)} clubImg={clubImg!} isFromClub={true}/>
          )}
        </div>
    </div>
  )
}

export default PerformanceTab